import { createCollection } from 'lib/resource';
import { runOperation } from 'app/operations';
import store from 'app/store';
import ShowUser from 'resources/show-user/schema';
import ShowUsers from './schema';

export default createCollection(
  ShowUsers,
  ShowUser,
  {
    getState: () => store.get().getState(),
    runOperation,
    implements: [],
  },
  {
    selectEntities: list => list,
  }
);
